



















































import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import EmojiPicker from '@/plugins/emoji/EmojiPicker.vue';

@Component({
    components: { EmojiPicker }
})
export default class InputText extends Vue {
	@Prop({ type: String, required: true })
	value!: string;

	@Prop({ type: String, required: false, default: '' })
	label!: string;

	@Prop({ type: String, required: true })
	name!: string;

	@Prop({ type: [String, Object], required: false, default: '' })
	rules!: string | object;

	@Prop({ type: String, default: 'eager', validator: value => ['aggressive', 'eager', 'lazy', 'passive'].includes(value as string) })
	mode!: string;

	@Prop({ type: String, required: false, default: '#000' })
	color!: string;

	@Prop({ type: Boolean, required: false, default: false })
	autofocus!: boolean;

	@Prop({ type: Boolean, required: false, default: true })
	showErrors!: boolean;

	@Prop({ type: Boolean, required: false, default: false })
	hideTopMargin!: boolean;

	@Prop({ type: Boolean, required: false, default: false })
	emojis!: boolean;

	get id() {
	    return this.name + new Date().valueOf();
	}

	get isPasswordType() {
	    return this.$attrs.type === 'password';
	}

	get isTextArea() {
	    return this.$attrs.type === 'textarea';
	}

	get maxLength() {
	    return this.$attrs.maxlength;
	}

	public appendEmoji(emoji: string) {
	    this.$emit('input', this.$refs.input.value + emoji);
	}

	isPasswordVisible: boolean = false;

	toggleTextVisibility() {
	    const e = document.getElementById(this.id) as HTMLInputElement;
	    e.type = this.isPasswordVisible ? 'password' : 'text';
	    this.isPasswordVisible = !this.isPasswordVisible;
	}

	get listeners() {
	    // eslint-disable-next-line @typescript-eslint/no-unused-vars
	    const { input, ...listeners } = this.$listeners;
	    return listeners;
	}

	get hasValue(): boolean {
	    return this.value !== '' && this.value != null;
	}

	changedInput(event: any) {
	    this.$emit('input', event.target.value);
	}

	public $refs!: {
		input: HTMLInputElement;
	};
}
